/**
 * @param {KeyboardEvent} e
 * @returns  {boolean} Is the keyboard event for an arrow key
 */
export function isArrowKey(e) {
  const { keyCode } = e;
  return keyCode >= 37 && keyCode <= 40;
}

/**
 * @param {KeyboardEvent} e
 * @returns {array} [x, y] movement of the keyboard event
 */
export function getKeyCodeMovement(e) {
  switch (e.keyCode) {
    case 37:
      return [1, 0];
    case 38:
      return [0, 1];
    case 39:
      return [-1, 0];
    case 40:
      return [0, -1];
    default:
      return [0, 0];
  }
}

/**
 * @param {UIEvent} e
 * @returns {boolean} whether the event is a touch event
 */
export function isTouchEvent(e) {
  return e.touches !== undefined;
}

/**
 * @param {TouchEvent} event
 * @returns {boolean} if the event has two touch points
 */
export function hasTwoTouchPoints(event) {
  if (isTouchEvent(event)) {
    return event.touches && event.touches.length === 2;
  }
  return false;
}

/**
 * Normalizes touch and mouse events to return { x, y } coords
 *
 * @param {UIEvent} e
 * @returns {Object} x and y coordinates of the event
 */
export function normalizeTouch(e) {
  const p = isTouchEvent(e) ? e.touches[0] : e;
  return {
    x: p.clientX,
    y: p.clientY
  };
}
